import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_2 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_3 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_4 = { class: "mt-4 md:w-1/8" }

import {onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import {
    GetAccountManagerSettings, 
    GetAccountManagerSettingsResponse,
    UpdateAccountManagerSettings
} from "@/dtos";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountManagerSettings',
  setup(__props) {

const accountManagerSettings: Ref<GetAccountManagerSettingsResponse> = ref(new GetAccountManagerSettingsResponse());

const responseStatus = ref(null);
const updateSuccessful: Ref<Boolean> = ref(false);

onMounted(async () => {
    await client.get<GetAccountManagerSettingsResponse>(new GetAccountManagerSettings())
        .then(response => {
            accountManagerSettings.value = response;
        });
});

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;

    let request = accountManagerSettings.value;

    await client.post<ResponseStatus>(new UpdateAccountManagerSettings(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            class: "block text-sm font-medium text-gray-700",
            for: "firstName"
          }, "First Name", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "firstName",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountManagerSettings.value.firstName) = $event)),
            class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
            name: "firstName",
            type: "text"
          }, null, 512), [
            [_vModelText, accountManagerSettings.value.firstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            class: "block text-sm font-medium text-gray-700",
            for: "lastName"
          }, "Last Name", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "lastName",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountManagerSettings.value.lastName) = $event)),
            class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
            name: "lastName",
            type: "text"
          }, null, 512), [
            [_vModelText, accountManagerSettings.value.lastName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SaButton, {
          onClick: _withModifiers(submit, ["prevent"]),
          loading: isSubmitting.value,
          variant: "primary"
        }, null, 8, ["loading"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})